import { render, staticRenderFns } from "./Single.vue?vue&type=template&id=132f7203&"
import script from "./Single.vue?vue&type=script&lang=js&"
export * from "./Single.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\vsProject\\dsf-product-exam\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('132f7203')) {
      api.createRecord('132f7203', component.options)
    } else {
      api.reload('132f7203', component.options)
    }
    module.hot.accept("./Single.vue?vue&type=template&id=132f7203&", function () {
      api.rerender('132f7203', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "pc/components/QuestionItem/Single.vue"
export default component.exports